import { useLocation } from 'react-router-dom';
import { segment } from '@/configurations/trackers/segment';
export function TrackNavigation() {
    var location = useLocation();
    segment.trackNavigation(location.pathname);
    return null;
}
